/* eslint-disable prettier/prettier */
import React from "react";
import MenuGroup from "@/components/header/components/menu/menu-group";
import CustomLink from "@/components/custom-link-react";
import Text from "@gerenciatd/next13.components.text";

const DefaultMenu = (props) => {
  if (!props["items"]) {
    return null;
  }
  const items = Object.values(props["items"]);
  const { location } = props;
  let i = 0;
  const updateSelected = (link, item) => {
    items.forEach(element => {
      if (element === item) {
        element.selected = true;
      } else {
        element.selected = false;
      }
    });
    window.location.href = link;
  }
  return (
    <>
      {items.map((item) => {
        const link = item.link ? item.link : "#";
        const text = item.text;

        var selectedItem = item.selected;

        if (!item.sections) {
          return (
            <CustomLink
              internal={false}
              href={link}
              onClick={() => { updateSelected(link, item) }}
              title={text}
              ariaLabel={text}
              key={`item-${i++}`}
              taggingInfo={{
                componentName: "header",
                componentContent: text,
                componentVariation: location,
                componentPerso: "",
                componentProduct: "",
              }}
              cyData={`Header item ${text}`}
            >
              <div className={`menu-item ${selectedItem ? " selected" : ""}`}>
                <Text
                  text={text}
                  fontType="font-regular"
                  size="caption01"
                  color="grey5"
                  display="block"
                />

              </div>
            </CustomLink>
          );
        } else {
          return <MenuGroup key={`item-${i++}`} item={item} />;
        }
      })}
    </>
  );
};
export default DefaultMenu;
